module.exports = __webpack_public_path__ + "static/media/aboutimg4.64f1316f.webp";